/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import OnlinePayWithAlipayDetailsComponent from './onlinePayWithAlipay.component';

const OnlinePayWithAlipayModule = angular.module('tinaba.components.services.onlinePayWithAlipay', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.onlinePayWithAlipay', {
        url: '/onlinePayWithAlipay',
        template: '<online-pay-with-alipay-details></online-pay-with-alipay-details>'
    });
})
.component('onlinePayWithAlipayDetails', OnlinePayWithAlipayDetailsComponent);

export default OnlinePayWithAlipayModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/onlinePayWithAlipay/onlinePayWithAlipay.js
 **/